import {Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-information-popup',
  templateUrl: './information-popup.component.html',
  styleUrls: ['./information-popup.component.css']
})
export class InformationPopupComponent {

  constructor(public dialogRef: MatDialogRef<InformationPopupComponent>) {
  }

  /**
   * Closes the modal dialog. If a checkbox is checked, saves a flag in localStorage to indicate the information popup state.
   */
  public closeModal(): void{
    localStorage.setItem("informationPopup", String(true));
    this.dialogRef.close();
  }

}
